import React, { Component } from 'react'
import { Project } from '../../schema/types.d'

interface Props {
  project: Project.Project
}
class ProjectThumbnail extends Component<Props> {
  render() {
    const project = this.props.project
    return (
      <article className="group-5-copy-3">
        <div className="projectNumber">#{project.projectNumber}</div>
        <div className="projectName">{project.name}</div>
        <div className="projectNumber">{project.client}</div>
        <div className="progress">87% progress</div>
        <div className="mask-copy" />
        <div className="mask" />
      </article>
    )
  }
}

export default ProjectThumbnail
